import { render, staticRenderFns } from "./ProductPurchaseRequest.vue?vue&type=template&id=f9afb1ec&scoped=true&"
import script from "./ProductPurchaseRequest.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchaseRequest.vue?vue&type=style&index=0&id=f9afb1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9afb1ec",
  null
  
)

export default component.exports